import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { FETCH_BRAND } from '../../_common/redux/brands/actions'
import { Link } from 'react-router-dom'

const StripeConnectComplete = props => {
  const [brand, setBrand] = useState(null)
  useEffect(() => {
    props.FETCH_BRAND(props.match.params.id).then(response => {
      setBrand(response.data)
    })
  }, [])
  window.localStorage.setItem('stripe-connected', true)

  return (
    <div className="brand-stripe-connect-complete">
      <p>Stripe account has been successfully connected.</p>
      <div className="link-buttons">
        <Link
          className="btn btn-lightpurple event-button-sm"
          to={brand ? `/events/new?brandId=${brand?.id}&displayName=${brand?.displayName}` : undefined}
        >
          {brand ? 'Create Event Now' : <i className="fa fa-circle-o-notch fa-spin loading_spinner" />}
        </Link>
        <Link className="btn btn-default event-button-sm" to={`/brand/${props.match.params.id}`}>
          View Brand Details
        </Link>
      </div>
    </div>
  )
}

export default connect(null, {
  FETCH_BRAND,
})(StripeConnectComplete)
